/**
 * Storage key for saving dictionary of draft posts by store id
 */
export const POST_MANAGER_DRAFTS = 'postManagerDrafts';
